import { render, staticRenderFns } from "./ListPromotionAcc.vue?vue&type=template&id=16e64eac&scoped=true"
import script from "./ListPromotionAcc.vue?vue&type=script&lang=js"
export * from "./ListPromotionAcc.vue?vue&type=script&lang=js"
import style0 from "./ListPromotionAcc.vue?vue&type=style&index=0&id=16e64eac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e64eac",
  null
  
)

export default component.exports